/**
 * «ع | EN» — the language switch, shown only where the policy offers both.
 * In the header of every dashboard and on the sign-in screens.
 */

import { Icon } from '../components/common';
import { useI18n } from './I18nProvider';

export function LanguageSwitch({ className = '', compact = false }) {
  const { lang, setLang, canSwitch, t } = useI18n();
  if (!canSwitch) return null;
  return (
    <div className={`lang-switch ${className}`} role="group" aria-label={t('lang.switch')} data-testid="lang-switch">
      {!compact && <Icon name="languages" size={15} className="lang-switch__icon" />}
      {['ar', 'en'].map((code) => (
        <button
          key={code}
          type="button"
          lang={code}
          aria-pressed={lang === code}
          className={`lang-switch__btn ${lang === code ? 'is-on' : ''}`}
          onClick={() => setLang(code)}
          data-lang={code}
        >
          {code === 'ar' ? 'ع' : 'EN'}
        </button>
      ))}
    </div>
  );
}

export default LanguageSwitch;
